export enum InteractionType {
  ExternalToInternal = 'external_to_internal',
  InternalToExternal = 'internal_to_external',
  Unknown = 'unknown',
}
